<template>
	<div id="usre-baseinfor" class="oh">
		<leftnav class="fl" mkcode="F" itemcode="F-JBZL"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''" >
			<govheader></govheader>
			<div class="index_left_centerpage"> 
			<div class="whitebox right_topbox">
				<div class="right_boxtitle">
					<span class="fl right_title">基本资料</span>  
					<video-teaching :type="6" style="line-height:46px"></video-teaching>
				</div>
						<div class="usre-baseinfor usermg">
							<div class="inputbox">
								<label>{{usertypename}}名称</label><div class="fl">{{userinfor.name}}</div>
							</div>
							<div class="inputbox">
								<label>账 号</label><div class="fl">{{userinfor.username}}</div>
							</div>
							<div class="inputbox">
								<label>负责人</label><div class="fl"><input type="text" placeholder="负责人" @change="editbtn=true" v-model="userinfor.contact"></div>
							</div>
							<div class="inputbox">
								<label>联系方式</label><div class="fl"><input type="text" placeholder="联系方式" @change="editbtn=true" v-model="userinfor.mobile"></div>
							</div>
							<div class="inputbox">
								<label>地址</label>
								<div class="fl">
									<p class="fl">{{userinfor.area}}</p>
									<input type="text" placeholder="详细地址" v-model="userinfor.adress" @change="editbtn=true">
								</div>  
							</div>
							<div :class="editbtn?'submitbtn editsave':'submitbtn'" @click="saveeditFun()">保存</div>
						</div>
			</div>
			</div>
		</div>
	</div>
</template> 
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'baseinformation',
	  computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	  data(){return{
				userdata:{},
				usertypename:'企业',
				title:'用户中心-基本资料',
				editbtn:false,
				userinfor:{
					name:'',username:"",mobile:'',contact:'',area:'',adress:'',
				}
			}},
		 created() {
		 	this.userdata=this.getuseriformation();
				if(this.userdata.userType == 1){
					this.usertypename="政府";
				}; 
		 },
			mounted() {
				this.getbaseinfo();
			},
			methods:{ 
				saveeditFun(){
					if(this.editbtn){  
						var ajaxurl=this.$api.cyl.usercenter.updatebaseinfor();
						var _this=this; 
						$.ajax({
							type:"POST",
							url:ajaxurl,
							data:{contact:this.userinfor.contact,mobile:this.userinfor.mobile,adress:this.userinfor.adress,},
							headers:{AuthToken:this.userdata.token },
							success:function(res){ 
								console.log(res); 
								if(res.success){
									 _this.editbtn=false;
								} 
							} 
						}); 
					}
				},
				getbaseinfo(){
					var _this=this;
					this.$axios.get(this.$api.cyl.usercenter.baseinfo(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
						console.log(res.data.data)
						if(res.data.success){  
							 _this.userinfor=res.data.data;
						} 
					}) 
				}, 
				
			}
	}  
</script>

<style>
	
</style>
